import {
  FileArchiveIcon,
  FileCodeIcon,
  FileIcon,
  FileImageIcon,
  FileSpreadsheetIcon,
  FileTextIcon,
} from 'lucide-react'
import type { FC } from 'react'

export const FILE_ICON_COMPONENTS: Record<string, FC<{ className?: string }>> = {
  FileText: FileTextIcon,
  FileSpreadsheet: FileSpreadsheetIcon,
  FileImage: FileImageIcon,
  FileCode: FileCodeIcon,
  FileArchive: FileArchiveIcon,
  File: FileIcon,
}

export const resolveFileIcon = (iconName: string): FC<{ className?: string }> =>
  FILE_ICON_COMPONENTS[iconName] ?? FileIcon

const MAX_FILENAME_LENGTH = 24

export const truncateFilename = (name: string): string => {
  if (name.length <= MAX_FILENAME_LENGTH) return name

  const extension = name.includes('.') ? name.slice(name.lastIndexOf('.')) : ''
  const baseName = name.slice(0, name.length - extension.length)
  const truncatedBase = baseName.slice(0, MAX_FILENAME_LENGTH - extension.length - 3)

  return `${truncatedBase}...${extension}`
}
